import { CallDetailsTabs } from '..';
import { Badge, CloseButton } from '../../../../../components';
import { statusConfig } from '../../utils/const';
import type { CallStatus } from '../../utils/const';

export interface CallTaskDetailsPanelProps {
  call: {
    contactName: string;
    phoneNumber: string;
    status: CallStatus;
    dateTime: string;
    duration: string;
    retryAt: string;
    voiceMailLeft: string;
  };
  onClose: () => void;
}

export const CallsTaskDetailsPanel = ({
  call,
  onClose,
}: CallTaskDetailsPanelProps) => {
  if (!call) return null;

  return (
    <div className="w-full h-full bg-white shadow-lg border-l p-6 overflow-y-hidden rounded-lg">
      <div className="flex justify-between items-center border-b pb-2 mb-4">
        <div className="flex flex-col">
          <h2 className="text-xl font-semibold">{call.contactName}</h2>
          <p>{call.phoneNumber}</p>
        </div>
        <CloseButton onClick={onClose} />
      </div>
      <div className="space-y-2 h-[calc(100%-4rem)] overflow-y-auto">
        <div className="flex items-center justify-between">
          <div className="text-secondary">Status:</div>
          <Badge status={call.status} config={statusConfig} />
        </div>
        <div className="flex items-center justify-between">
          <div className="text-secondary">Date & Time:</div> {call.dateTime}
        </div>
        <div className="flex items-center justify-between">
          <div className="text-secondary">Duration:</div> {call.duration}
        </div>
        <div className="flex items-center justify-between">
          <div className="text-secondary">Retry At:</div> {call.retryAt}
        </div>
        <div className="flex items-center justify-between">
          <div className="text-secondary">Voice Mail Left:</div>
          {call.voiceMailLeft}
        </div>

        <div className="h-[85%] overflow-y-auto">
          <CallDetailsTabs />
        </div>
      </div>
    </div>
  );
};
